import iso from "@/assets/certs/iso.png.asset.json";
import abnt from "@/assets/certs/abnt.png.asset.json";
import ansn from "@/assets/certs/ansn.png.asset.json";

const certifications = [
  { logo: iso.url, label: "ISO/IEC 17025" },
  { logo: abnt.url, label: "ABNT NBR ISO/IEC 17025 — CRL 1266" },
  { logo: ansn.url, label: "Autoridade Nacional de Segurança Nuclear" },
];

const CertificationBar = () => (
  <div className="bg-card border-b border-border py-4 sm:py-5">
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-3 gap-3 sm:flex sm:flex-wrap sm:items-center sm:justify-center sm:gap-x-10 sm:gap-y-4">
        {certifications.map((c) => (
          <div
            key={c.label}
            className="flex flex-col sm:flex-row items-center justify-center sm:justify-start gap-2 sm:gap-3 text-muted-foreground text-center sm:text-left"
          >
            <img
              src={c.logo}
              alt={c.label}
              loading="lazy"
              className="h-8 sm:h-10 w-auto object-contain shrink-0"
            />
            <span className="font-heading text-[11px] leading-snug sm:text-sm font-semibold sm:max-w-[180px]">
              {c.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default CertificationBar;
